// How the hub addresses the BD (TX-US-0028): by first name, asking for the day's update until
// there is one.

// The first name out of what /api/me knows: the display name's first word, or the part of the
// address before the dot or the @ when there is no name.
export function firstName(me) {
  const named = me.display_name?.trim().split(/\s+/)[0];
  if (named) return named;
  const local = me.email.split('@')[0].split('.')[0];
  return local.charAt(0).toUpperCase() + local.slice(1);
}

export const greeting = (me, submittedToday) => (submittedToday
  ? `Thank you, ${firstName(me)} - today's update is in. Add another if there is more.`
  : `${firstName(me)}, please provide your daily update.`);
